import React from "react";
import axios from "axios";

import RichTextEditor from "../pages/CmsPages/RichTextEditor";

// Legacy wrapper kept for backward compatibility. It now renders the SAME
// CKEditor 5 used everywhere else in the admin (CMS Pages + blog/news/events
// forms) instead of the old decoupled-document v15 build, so editing looks and
// behaves identically throughout the site. Unlike the old version, it loads the
// existing content (feedDetail / editorBody) instead of a hardcoded "hello".
const Editor = ({ feedId, feedDetail, editorBody, setEditorBody }) => {
  const initial = editorBody || (feedId ? feedDetail : "") || "";
  return (
    <RichTextEditor
      value={initial}
      onChange={setEditorBody}
      uploadUrl={`${axios.defaults.baseURL || ""}/upload`}
      token={localStorage.getItem("accessToken")}
    />
  );
};

export default Editor;
